export default __webpack_public_path__ + "static/media/io.7ebce74f.jpg";